<template>
	<div style="background-color: white;">
		<template v-if="configShow">
			<vxe-toolbar>
				<template #buttons>
					<vxe-button status="success" @click="importwarehouse">导入仓库</vxe-button>
					<vxe-button status="primary" @click="onSubmit">保存</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table border ref="cityWarehouseOrder" height="400" class="sortable-row" :row-config="{useKey: true}"
				:scroll-y="{enabled: true}" :data="tableData">
				<vxe-column width="60" title="拖动">
					<template #default>
						<span class="drag-btn">
							<i class="vxe-icon-edit"></i>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="优先级" type="seq"></vxe-column>
				<vxe-column field="warehousecode" title="仓库编码"></vxe-column>
				<vxe-column field="warehousewlnname" title="万里牛名称"></vxe-column>
				<vxe-column field="warehousename" title="云系统名称"></vxe-column>
			</vxe-table>
		</template>
	</div>

</template>
<style scoped>

</style>
<script>
	import Sortable from 'sortablejs'
	export default {
		props: {
			currentitem: {
				default: () => {
					return null
				}
			},
			emunid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				configShow:false,
				loading: false,
				tableData: []
			}
		},
		watch: {
			emunid() {
				this.get()
			},
			currentitem(e){
				if(e){
					this.configShow = true
				}else{
					this.configShow = false
				}
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			rowDrop() {
				this.$nextTick(() => {
					const xTable = this.$refs.cityWarehouseOrder
					this.sortable1 = Sortable.create(xTable.$el.querySelector(
						'.body--wrapper>.vxe-table--body tbody'), {
						handle: '.drag-btn',
						onEnd: ({
							newIndex,
							oldIndex
						}) => {

							const currRow = this.tableData.splice(oldIndex, 1)[0]
							this.tableData.splice(newIndex, 0, currRow)
							console.log(this.tableData)
						}
					})
				})
			},
			importwarehouse() {
				console.log(window.systemData.warehouse)
				this.tableData = window.systemData.warehouse.map((item) => {
					return {
						warehouseid: item.id,
						warehousecode: item.code,
						warehousewlnid: item.wlnid,
						warehousewlnname: item.wlnname,
						warehousename: item.name,
					}
				})
				this.$nextTick(() => {
					this.rowDrop()
				})
			},
			get() {
				if (!this.emunid) {
					this.$message.error('请选择城市')
					return
				}
				this.loading = true
				this.$api.emunextend_city.get(this.emunid,{type:'priority'}).then((res) => {
					this.loading = false
					this.tableData = res
					this.$nextTick(() => {
						this.rowDrop()
					})
				})
			},
			onSubmit() {
				if (!this.emunid) {
					this.$message.error('请选择城市')
					return
				}
				this.tableData.forEach((item, index) => {
					item.index = index + 1
					item.emunvalueid = this.emunid
				})
				
				
				this.$api.emunextend_city.save('priority',{
					data: this.tableData
				}).then(() => {
					this.$message.success('操作成功')
				})

			}
		},
		components: {


		}
	}
</script>
